/*
 * @Author: zhouwei
 * @Date: 2019-10-18 13:58:32
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-07 17:08:00
 * @Desc: 全体成员/指定成员
*/
<template>
  <div class="executive">
    <div class="executive-select">
      <mk-radio-group
        :value="value"
        v-bind="$attrs"
        size="medium"
        class="select-radio"
        v-on="$listeners"
        @change="change"
      >
        <mk-radio-button
          v-for="item in items"
          :key="item.id"
          :label="item.name"
        ></mk-radio-button>
      </mk-radio-group>
      <div
        v-if="value === '指定成员'"
        class="btn-group"
      >
        <mk-button-biz
          type="text"
          icon="el-icon-plus"
          @click="addDepartment"
        >
          添加部门
        </mk-button-biz>
        <mk-button-biz
          type="text"
          icon="el-icon-plus"
          @click="addPerson"
        >
          添加成员
        </mk-button-biz>
        <div
          v-if="showD"
          class="add-department"
        >
          <div class="add-department-content">
            <div class="title">
              <span>添加部门</span>
              <mk-iconfont
                class="close"
                icon-class="guanbi"
                @click.native="closeD"
              ></mk-iconfont>
            </div>
            <div class="content">
              <span>部门：</span>
              <mk-cascader
                ref="department"
                v-model="department"
                width="240px"
                :options="options"
                :props="props"
                filterable
                clearable
                collapse-tags
                placeholder="选择部门(可多选)"
                @change="changeDe"
              ></mk-cascader>
            </div>
            <div class="btn">
              <mk-button-biz
                width="63px"
                height="32px"
                @click="closeD"
              >
                取消
              </mk-button-biz>
              <mk-button-biz
                width="63px"
                height="32px"
                type="primary"
                @click="addD"
              >
                添加
              </mk-button-biz>
            </div>
          </div>
        </div>
        <div
          v-if="showP"
          class="add-department"
        >
          <div class="add-department-content">
            <div class="title">
              <span>添加成员</span>
              <div>
                <mk-iconfont
                  class="close"
                  icon-class="guanbi"
                  @click.native="closeP"
                ></mk-iconfont>
              </div>
            </div>
            <div class="content">
              <span>成员：</span>
              <mk-select
                v-model="personal"
                :props="props"
                filterable
                multiple
                clearable
                collapse-tags
                placeholder="选择成员(可多选)"
                width="256"
              >
                <mk-option
                  v-for="item in pOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled"
                >
                </mk-option>
              </mk-select>
            </div>
            <div class="btn">
              <mk-button-biz
                width="63px"
                height="32px"
                @click="closeP"
              >
                取消
              </mk-button-biz>
              <mk-button-biz
                type="primary"
                width="63px"
                height="32px"
                @click="addP"
              >
                添加
              </mk-button-biz>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="value === '指定成员' && (mySelectD.length > 0 || mySelectP.length > 0)"
      class="show-select"
    >
      <mk-tag
        v-for="(tagD,indexD) in mySelectD"
        :key="'d-'+indexD"
        class="select-item"
        closable
        :disable-transitions="false"
        @close="handleClose(tagD)"
      >
        {{ getName(tagD) }}
      </mk-tag>
      <mk-tag
        v-for="(tagP,indexP) in mySelectP"
        :key="'p-'+indexP"
        class="select-item"
        closable
        :disable-transitions="false"
        @close="handleCloseP(tagP)"
      >
        {{ myPer[tagP] }}
      </mk-tag>
    </div>
  </div>
</template>
<script>
/**
 * 以下代码出现的p和d均为个人和组织的缩写
 *  */
import { BIZAPIS } from '../../../../../api'
export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '全体成员'
    },
    /**
     * type类型：add新增, detail详情
     */
    type: {
      type: String,
      default: 'add'
    },
    initPersonArr: {
      type: Array,
      default () {
        return []
      }
    },
    initDeperArr: {
      type: Array,
      default () {
        return []
      }
    },
    list: {
      type: Object,
      default () {
        return {
          isAll: true
        }
      }
    }
  },
  data () {
    return {
      inintOptions: {
        data: []
      },
      initOptionsP: {
        data: []
      },
      personError: true,
      mySelectD: [], // 选择部门结果
      myChangeD: [], // 多选change,获取最外层选择数组
      mySelectDPer: {
        isAll: false,
        children: []
      }, // 选择部门下的所有人
      mySelectP: [], // 选择人员结果
      val: '', // 单选项的值
      department: [], // 公司组织架构
      personal: '',
      showD: false, // 是否展示公司组织架构
      showP: false, // 是否展示所有销售
      items: [
        {
          id: 0,
          name: '全体成员'
        },
        {
          id: 1,
          name: '指定成员'
        }
      ],
      props: {
        multiple: true,
        value: '_id',
        label: 'name',
        disabled: 'disabled'
      },
      options: [],
      pOptions: [],
      allSales: {}, // 全体成员
      myDepartment: {}, // 键值对获取部门名称
      myPer: {} // 键值对获取个人名称
    }
  },
  watch: {
    initPersonArr (val) {
      // {_id: 'xxx',name: 'xxx'}
      if (this.initPersonArr && this.initPersonArr.length > 0) {
        let data = this.initPersonArr
        let arr = []
        data.forEach((item, index) => {
          arr[index] = item._id
        })
        this.getAllSales(false, 'init', arr)
      }
    },
    initDeperArr (val) {
      if (this.initDeperArr && this.initDeperArr.length > 0) {
        let data = this.initDeperArr
        let arr = []
        data.forEach((item, index) => {
          arr[index] = item._id
        })
        this.getCompanyStructure(false, 'init', arr)
      }
    },
    mySelectD (val) {
      let data = [] // emit数据结构
      if (val && val.length > 0) {
        val.forEach((item, index) => {
          let id = ''
          if (item instanceof Array) {
            id = item[item.length - 1]
          } else {
            id = item
          }
          let name = this.myDepartment[id]
          data[index] = {
            id: id,
            name: name,
            type: 1
          }
        })
        this.$emit('changeDepart', data)
      }
    },
    mySelectP (val) {
      this.$emit('changePerson', val)
    }
  },
  created () {
    // 获取公司组织架构
    // 页面摧毁无法更改props传递过来的数值,故使用此方法
    if (this.initPersonArr && this.initPersonArr.length > 0) {
      let data = this.initPersonArr
      let arr = []
      data.forEach((item, index) => {
        arr[index] = item._id
      })
      this.getAllSales(false, 'init', arr)
    } else {
      this.getAllSales(false)
    }
    if (this.initDeperArr && this.initDeperArr.length > 0) {
      let data = this.initDeperArr
      let arr = []
      data.forEach((item, index) => {
        arr[index] = item._id
      })
      this.getCompanyStructure(false, 'init', arr)
    } else {
      this.getCompanyStructure(false)
    }
  },
  methods: {
    changeDe (e) {
      /**
       * 此选择结果为[level1, level2,level3,level4,newLevel2,newLevel3]
       * 首选项必为最外层选项
       * 禁用项为首选项
       */
      let arr = this.$refs.department.$children[0].getCheckedNodes()
      let newArr = []
      this.myChangeD = []
      if (arr && arr.length > 0) {
        arr.forEach((item, index) => {
          if (item.checked) {
            if (
              item.parent === null ||
              item.parent === undefined ||
              (item.parent && item.parent.checked === false)
            ) {
              newArr.push(item.value)
            }
          }
          this.myChangeD = newArr
        })
      }
    },
    handleClose (tag) {
      this.mySelectD.splice(this.mySelectD.indexOf(tag), 1)
    },
    handleCloseP (tag) {
      this.mySelectP.splice(this.mySelectP.indexOf(tag), 1)
    },
    // 取消添加部门
    closeD () {
      this.showD = false
      this.department = []
    },
    closeP () {
      this.showP = false
    },
    // 确认添加部门
    addD () {
      this.showD = false
      this.mySelectD = this.mySelectD.concat(this.myChangeD)
      this.myChangeD = []
      this.department = []
    },
    addP () {
      this.showP = false
      this.mySelectP = this.mySelectP.concat(this.personal)
      this.personal = []
    },
    addDepartment () {
      this.getCompanyStructure(true)
    },
    handleDisabled (arr1) {
      // 再次点击进入禁用已有项目
      if (this.mySelectD.length > 0) {
        if (arr1 instanceof Array) {
          arr1.forEach((item1, index1) => {
            this.mySelectD.forEach((item2, index2) => {
              if (item1._id === item2) {
                item1.disabled = true
              } else {
                this.handleDisabled(item1.children)
              }
            })
          })
        }
      }
    },
    handleDisabledP (arr) {
      if (this.mySelectP.length > 0) {
        if (arr instanceof Array) {
          arr.forEach((item, index) => {
            this.mySelectP.forEach((item2, index2) => {
              if (item.id === item2) {
                item.disabled = true
              }
            })
          })
        }
      }
    },
    addPerson () {
      this.getAllSales(true)
    },
    change (e) {
      this.$emit('change', e)
    },
    async getAllSales (state, init, arr) {
      // 获取所有销售
      const res = await BIZAPIS.UserApi.timingPlanAllUsersGet({})
      if (res.success) {
        let data = res.data.data
        if (data && data.length > 0) {
          let i = 0
          let len = data.length
          let myData = []
          let perData = []
          for (i; i < len; i++) {
            myData[i] = {
              type: 0,
              id: data[i]._id,
              name: data[i].name,
              children: []
            }
            this.myPer[data[i]._id] = data[i].name
          }
          this.allSales = {
            isAll: true,
            children: myData
          }
          this.pOptions = myData
          this.handleDisabledP(this.pOptions)
          if (state) {
            this.showP = true
          } else {
            this.$emit('create', {
              isAll: true,
              children: myData
            })
          }
          if (init === 'init') {
            this.mySelectP = arr
          }
        } else {
          this.$alert('尚未查询到公司任何人员信息，不能添加营销计划', '提示', {
            confirmButtonText: '确认退出',
            callback: action => {
              history.go(-1)
            }
          })
        }
      }
    },
    async getCompanyStructure (state, init, myArr) {
      // 获取公司架构
      const res = await BIZAPIS.UserApi.timingPlanDepartmentAllGet({})
      if (res.success) {
        let arr = []
        if (res.data && res.data.length > 0) {
          this.options = res.data
          let arr = res.data
          arr.push({
            _id: 'NA',
            name: '无部门',
            parentId: 'NA',
            level: 1
            // children: []
          })
          this.recursion(this.options) // 删除多余的children,否则无法获取选择结果
          this.handleDisabled(this.options) // 禁止已选项
          this.getDepartmentName(this.options) // 显示选择结果
          if (init === 'init') {
            this.mySelectD = myArr
          }
          if (state) {
            this.showD = true
          }
        } else {
          if (state) {
            this.$message({
              type: 'error',
              message: '该账户下无部门信息,请联系管理员添加',
              showClose: true
            })
          }
        }
      }
    },
    recursion (arr) {
      // 删除children为空数组的属性值
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          if (item && item.children && item.children.length > 0) {
            this.recursion(item.children)
          } else {
            delete item.children
          }
        })
      }
    },
    getDepartmentName (arr) {
      // 将个人信息id和name组成键值对
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          if (item && item._id) {
            this.myDepartment[item._id] = item.name
          }
          this.getDepartmentName(item.children)
        })
      }
    },
    getName (tag) {
      let str = ''
      if (tag instanceof Array) {
        tag.forEach((item, index) => {
          if (index === tag.length - 1) {
            str = this.myDepartment[tag[index]]
          }
        })
      } else {
        str = this.myDepartment[tag] || ''
      }
      return str
    }
  }
}
</script>
<style lang="scss" scoped>
.executive {
  position: relative;

  .executive-select {
    display: flex;
    height: 40px;
    align-items: center;
  }

  .select-radio {
    float: left;
  }

  .btn-group {
    line-height: 32px;
    margin-left: 10px;
  }

  .add-department {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 99;

    .add-department-content {
      display: inline-block;
      background: #fff;
      width: 360px;
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      color: #262626;

      .title {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
        width: 360px;
        height: 54px;
        box-sizing: border-box;
        padding: 0 20px;
        background: rgba(251, 252, 253, 1);
        box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
        border-radius: 4px 4px 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .close {
          color: #bfbfbf;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
        }
      }

      .content {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          margin-right: 12px;
          color: #262626;
          font-size: 13px;
        }
      }

      .btn {
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        justify-content: flex-end;
        margin-top: 37px;
        margin-bottom: 20px;
      }
    }
  }

  .show-select {
    margin-top: 16px;

    .select-item {
      margin: 0 8px 8px 0;
    }
  }
}
</style>
